export default __webpack_public_path__ + "static/media/Login_form_img_2.7a57c46c.svg";